import * as yup from "yup";

export const rejectNoteSchema = yup.object().shape({
    note: yup.string().required().default("").label("Note"),
});
